import { lazy } from 'react';

export default {
    path: '/:companyId/reports/request/:reportId',
    component: lazy(() => import(/* webpackChunkName: "manager-pages" */ './page')),
};
